module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"title":"Архів сповіщень"}}')
  delete Component.options._Ctor
}
